<template>
  <div>
    <el-table :data="projects">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="nowAmount" label="已存金额"></el-table-column>
      <el-table-column prop="minAmount" label="存入最小额度"></el-table-column>
      <el-table-column prop="scale" label="精度"></el-table-column>
      <el-table-column prop="defaultRate" label="违约费率">
        <template slot-scope="scope"
          >{{ scope.row.defaultRate * 100 }}%</template
        >
      </el-table-column>
      <el-table-column prop="userCount" label="已存次数"></el-table-column>
      <el-table-column label="是否允许存入">
        <template slot-scope="scope">
          <span v-if="scope.row.status">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="查看记录">
            <router-link
              :to="{
                path: '/home/cornucopia/pledgeRecord',
                query: { id: scope.row.id }
              }"
            >
              <el-button
                type="primary"
                size="small"
                circle
                icon="el-icon-view"
              ></el-button>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'pledgeCornucopia',
  computed: {
    ...mapState('pledgeCornucopia', ['projects', 'pagination', 'totalCount'])
  },
  components: {
    Detail,
    Pagination
  },
  methods: {
    ...mapMutations('pledgeCornucopia', ['setEditingProject']),

    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
.el-tooltip {
  margin-right: 7px;
}
</style>
